export default __webpack_public_path__ + "static/media/dreamfest (14).715e61f4.jpg";